module.exports = new __parcel__URL__("diag.e6af899a.png").toString();